export enum PreferencesServiceError {
  UserPreferencesNotInitialized = 'preferences-service/user-preferences-not-initialized',
  InvalidPreferencesSelection = 'preferences-service/invalid-preferences-selection',
}
